<script>
	import Tailwindcss from './Tailwindcss.svelte';

	document.body.classList.add('bg-gradient-to-br', 'from-gray-700', 'to-gray-900', 'p-0')

	let dayText, hoursText, minText, secText
	const countdown = () => {
		const countDate = new Date('Aug 17 2022 00:00:00 UTC+1').getTime();
		const today = new Date().getTime();
		const diff = countDate - today

		const sec = 1000;
		const min = sec * 60;
		const hours = min * 60;
		const days = hours * 24;

		dayText = Math.floor(diff / days);
		hoursText = Math.floor((diff % days) / hours);
		minText = Math.floor((diff % hours) / min);
		secText = Math.floor((diff % min) / sec);
	}
	countdown();
	setInterval((countdown), 1000);

	function eier() {
		alert("Hier kommt für Lulas noch irgendwann was hin!")
	}
</script>

<Tailwindcss />
<main>
	<div class="flex flex-col justify-center items-center h-screen">
		<p class="flex-initial text-white font-medium text-3xl text-center p-2">Noch</p>
		<p class="flex-initial text-white font-semibold text-4xl text-center p-2">{dayText} Tage {hoursText} Stunden {minText} Minuten {secText} Sekunden</p>
		<p class="flex-initial text-white font-medium text-3xl text-center p-2">bis die Ausbildung vorbei ist.</p>
		<img src="images/urbi.JPG" alt="Unser Mann!" style="width: 10%" class="pt-8 transform duration-100 hover:rotate-180" on:click={eier}>
	</div>
</main>

<style>
</style>
